'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Route } from 'react-router-dom';
import { usageTracker } from 'AdsUI/lib/usageTracker';

function TrackedRoute(_ref) {
  let {
    children,
    name
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["children", "name"]);

  useEffect(() => {
    usageTracker.track('pageView', {
      screen: name
    });

    if (name !== 'campaigns-list') {
      window.HS_SKIP_CUSTOM_PERF = true;
    }
  }, [name]);
  return /*#__PURE__*/_jsx(Route, Object.assign({}, rest, {
    children: children
  }));
}

export default TrackedRoute;